import script from "./AppLoadingContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppLoadingContent.vue?vue&type=script&setup=true&lang=ts"

import "./AppLoadingContent.vue?vue&type=style&index=0&id=3be01b48&lang=sass"

const __exports__ = script;

export default __exports__